// extracted by mini-css-extract-plugin
module.exports = {"draggableIcon":"DraggableIcon_draggableIcon_1r8fF"};